import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import App from './App.vue'
import router from './routes.js';
import VueRouter from 'vue-router';
import vuetify from './plugins/vuetify';
import store from './store';
import axios from 'axios';
import VuetifySnackbarQueue from 'vuetify-snackbar-queue';
import titleMixin from './mixins/titleMixin';
import moment from 'moment';
import VueI18n from 'vue-i18n';

moment.locale('ru');

import './styles/custom-reset.css';

import VueApexCharts from 'vue-apexcharts';

import JsonViewer from 'vue-json-viewer';

Vue.use(JsonViewer);
Vue.component('vue-json-viewer', JsonViewer);

import { LMap, LTileLayer, LMarker, LControl, LGeoJson, LRectangle, LCircleMarker } from 'vue2-leaflet';
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
import { Icon } from 'leaflet'

import 'leaflet-draw/dist/leaflet.draw'
import 'leaflet-draw/dist/leaflet.draw.css'

import 'leaflet/dist/leaflet.css'

Vue.use(VueI18n);
Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-control', LControl);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-rectangle', LRectangle);
Vue.component('l-circle-marker', LCircleMarker);
Vue.component('l-marker-cluster', Vue2LeafletMarkercluster);


Vue.config.productionTip = false

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.prototype.$http = axios;
const token = localStorage.getItem('token');
axios.defaults.withCredentials = true;

axios.get('/app.settings.json')
  .then(async (response) => {
    Vue.prototype.$settings = response.data;
    axios.defaults.baseURL = Vue.prototype.$settings.VUE_APP_GATEWAY_SERVICE_ENDPOINT;
    if (token) {
      Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }

    Vue.use(VueRouter);
    Vue.mixin(titleMixin);

    Vue.use(VueApexCharts);
    Vue.component('apexchart', VueApexCharts);

    Vue.use(VuetifySnackbarQueue);
    await store.dispatch('CHECK');

    new Vue({
      render: h => h(App),
      vuetify,
      store,
      router
    }).$mount('#app');

  });
